<template>
  <div class="container mt-4">
    <div class="card shadow p-4 border-0" style="border-radius: 16px;">
      
      <h4 class="mb-4" style="color: #b03a45;">
        <i class="fas fa-gift me-2" style="color: #b03a45;"></i>
        {{ $t("employeebonus.title") }}
      </h4>

      <!-- LOADING -->
      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border text-danger"></div>
        <div class="mt-2 text-muted">
          {{ $t("employeebonus.loading") }}
        </div>
      </div>

      <!-- EMPTY -->
      <div v-else-if="bonuses.length === 0" class="text-center text-muted my-4">
        {{ $t("employeebonus.empty") }}
      </div>

      <!-- TABLE -->
      <div v-else class="table-responsive">
        <table class="table table-bordered align-middle">
          <thead class="table-light">
            <tr>
              <th>{{ $t("employeebonus.table.project") }}</th>
              <th>{{ $t("employeebonus.table.amount") }}</th>
              <th>{{ $t("employeebonus.table.otherBonus") }}</th>
              <th>{{ $t("employeebonus.table.month") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="b in bonuses" :key="b.id">
              <td>{{ b.project?.name || "-" }}</td>
              <td>{{ Number(b.amount).toFixed(2) }} DT</td>
              <td>{{ Number(b.other_bonus || 0).toFixed(2) }} DT</td>
              <td>{{ b.bonus_month }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "@/api";

export default {
  name: "EmployeeMyBonus",

  data() {
    return {
      bonuses: [],
      loading: true,
    };
  },

  async mounted() {
    try {
      const response = await axios.get("/employee/user/myBonus");

      console.log("BONUS RESPONSE =", response.data);

      // Sécurisation au cas où la réponse n'est pas un tableau
      this.bonuses = Array.isArray(response.data) ? response.data : [];

    } catch (err) {
      console.error("ERROR =", err.response?.data || err);
      this.bonuses = [];
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.table th {
  background: #f8f9fa;
}
</style>
